import React, { PropsWithChildren } from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { CardColumnSpanCalculator } from '../../CardGrid';
import { StyledGrid } from './styles';

const getDesktopColumnSpan = (totalCards: number): number => {
  const colSpanForTwoItemRow = 6;
  const colSpanForThreeItemRow = 4;

  if (totalCards === 3) {
    return colSpanForThreeItemRow;
  }
  return colSpanForTwoItemRow;
};

const getTabletPortraitColumnSpan = (totalCards: number): number => {
  const colSpanForTwoItemRow = 4;
  const colSpanForThreeItemRow = 8;

  if (totalCards === 3) {
    return colSpanForThreeItemRow;
  }
  return colSpanForTwoItemRow;
};

export const columnSpanCalculator: CardColumnSpanCalculator = (
  index: number,
  totalCards: number
) => ({
  // mobile cards are always full-width
  tabletPortrait: getTabletPortraitColumnSpan(totalCards),
  tabletLandscape: getDesktopColumnSpan(totalCards),
  desktop: getDesktopColumnSpan(totalCards),
});

const ImageAndCtaCardGrid: React.FC<PropsWithChildren<ComponentProps>> = ({
  children,
  ...props
}) => (
  <StyledGrid {...componentProps(props)} columnSpanCalculator={columnSpanCalculator}>
    {children}
  </StyledGrid>
);

export default applyComponentTheme(ImageAndCtaCardGrid, 'ImageAndCtaCardGrid');
